<section class="header">
  <div class="placeholders">
    <div class="avatar-ph"></div>
    <div class="texts">
      <div class="text-ph"></div>
      <div class="text-ph text-ph--short"></div>
    </div>
  </div>
</section>
@if (!data.image) {
  <div class="empty-state-preview">
    <p>
      {{
        "publicationTemplatePost.uploadContentToMediaFilesForPreview"
          | translate
      }}
    </p>
  </div>
} @else {
  <section class="image">
    <img [src]="data.image.link" />
  </section>
}
<section class="footer">
  <div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
  </div>
  <div class="circle"></div>
</section>
@if (data.text?.length) {
  <div class="text" [innerHTML]="data.text"></div>
}
